import * as React from 'react';
import ReactDOM from 'react-dom';

interface Props {
    children: React.ReactNode;
}

class Portal extends React.PureComponent<Props> {
    render() {
        const { children } = this.props;
        const element = document.getElementById('root');
        if (!element) return null;
        return ReactDOM.createPortal(children, element);
    }
}

export default Portal;
